import React from 'react'

import { useField } from 'formik'

import Label from '../components/Label'
import TextArea from '../components/TextArea'
import FieldProps from './FieldProps'
import Error from './FormItemError'

interface TextAreaProps extends FieldProps {
  cols?: number
  rows?: number
  wrap?: string
  disabled?: boolean
  maxLength?: number
  minLength?: number
  hint?: string
  inputStyles?: string
}

const FormikTextAreaField: React.FC<TextAreaProps> = ({ label, ...props }) => {
  const [field, meta] = useField(props)
  const showError = meta.touched && meta.error
  const id = props.id || props.name

  return (
    <div className="mb-8">
      <Label htmlFor={id} className="no-select hand-on-hover">
        {label}
        {props.hint && <span className="formik-field__span"> {props.hint}</span>}
      </Label>
      <TextArea {...field} {...props} id={id} className={props.inputStyles} />
      {showError && <Error>{meta.error}</Error>}
    </div>
  )
}

export { FormikTextAreaField as TextArea }
export default FormikTextAreaField
